import { isEmpty } from "lodash";
import React from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const DraggableProductTags = ({
    tags,
    setTags,
    emptyMessage,
    emptyElement,
    center,
    removeTagHandler,
    isColumn,
    keyName = "label",
}) => {
    const getEmptyContent = () => {
        if (emptyElement) {
            return emptyElement();
        } else {
            return <p>{emptyMessage || "---"}</p>;
        }
    };

    const renderTags = () => {
        return isEmpty(tags)
            ? getEmptyContent()
            : tags &&
                  tags.map((tag, index) => {
                      return (
                          <Draggable
                              key={index}
                              draggableId={`${index}`}
                              index={index}
                          >
                              {(provided) => (
                                  <li
                                      className="dnd-tags-items"
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                  >
                                      {tag[keyName] || tag}
                                      {removeTagHandler && (
                                          <i
                                              onClick={() =>
                                                  removeTagHandler(
                                                      tag[keyName] || tag,
                                                      index
                                                  )
                                              }
                                              className="fas fa-times-circle text-primary-orange fa-md cursor-pointer ml-2"
                                          ></i>
                                      )}
                                  </li>
                              )}
                          </Draggable>
                      );
                  });
    };

    const handleOnDragEnd = (result) => {
        if (result.destination) {
            const items = [...tags];
            const [reorderedItem] = items.splice(result.source.index, 1);
            items.splice(result.destination.index, 0, reorderedItem);

            setTags(items);
        }
    };
    return (
        <>
            <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable droppableId="tags-wrapper">
                    {(provided) => (
                        <ul
                            className={`tags-wrapper flex flex-wrap ${
                                isColumn
                                    ? "flex-col content-start justify-start items-start"
                                    : ""
                            } ${center ? "justify-center items-center" : ""}`}
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {renderTags()}
                            {provided.placeholder}
                        </ul>
                    )}
                </Droppable>
            </DragDropContext>
        </>
    );
};

export default DraggableProductTags;
